<template>
  <div class="tab-menu">
    <div v-for="(tab, index) in tabs"
         :key="index"
         class="tab-item"
         :class="styleSelected(tab)"
         @click="$router.push({ name: tab.name })">
      <div>
        <font-awesome-icon :icon="tab.icon" size="lg"/>
      </div>
      <div class="tab-title">
        {{ $l[tab.title] }}
      </div>
    </div>
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],
  data () {
    return {
      tabs: [
        { title: 'home', icon: 'home', name: 'home' },
        { title: 'mail', icon: 'envelope', name: 'message' },
        { title: 'event', icon: 'calendar-alt', name: 'event' },
        { title: 'map', icon: 'map-marker-alt', name: 'map' },
        { title: 'answer', icon: 'th', name: 'answer-sheet' },
        { title: 'settings', icon: 'cog', name: 'settings' }
      ]
    }
  },
  methods: {
    styleSelected: function (tab) {
      const result = this.tabs.find((t) => {
        return (t.name === this.$route.name && t.name === tab.name)
      })

      if (result) {
        return {
          'tab-selected': true
        }
      }
      return {}
    }
  }
}
</script>

<style lang="scss" scoped>
.tab {
  &-menu {
    border-top: 1px solid #95a5a6;
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    align-items: center;
  }

  &-item {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    width: 70px;
    color: #34495e;
    &:hover {
      cursor: pointer;
    }
  }

  &-selected {
    color: #3498db;
  }

  &-title {
    font-size: 0.8em;
  }
}
</style>
